export default "__VITE_ASSET__s_mweIcw__"